import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2';
import Select from "react-select";
import $ from "jquery";
import { loader_image } from "../_components/Imagepath";

import { IconButton, Tooltip, MenuItem } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { formatDistanceToNow } from 'date-fns';
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query';

// import "react-toastify/dist/ReactToastify.css";
const RawMaterial = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [dataalocation, setDataalocation] = useState([]);
  const [supplierName, setSupplierName] = useState([]);
  const [allnetweight, setAllnetweight] = useState(0);
  const [allblnetweight, setAllblnetweight] = useState(0);
  const [permission, setPermission] = useState({});
  const [groupproductLists, setGroupproductLists] = useState([]);

  const [locationLoading, setLocationLoading] = useState([]);

  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);


  const queryClient = useQueryClient();

  const [formData, setFormData] = useState({
    supplier: '',
    start_date: '',
    end_date: '',
    location: '',
    shift: '',
  });


  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0, // 0-based index for React Table
    pageSize: 10, // Default rows per page
  });

  // ✅ Define row.original PropTypes
  const rowOriginalShapemain = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    lot_number: PropTypes.string.isRequired,
    location_name: PropTypes.shape({
      title: PropTypes.string,
    }),
    date_time: PropTypes.string.isRequired,
    supplier_name: PropTypes.shape({
      name: PropTypes.string,
    }),
    plate_number: PropTypes.string,
    net_weight: PropTypes.number.isRequired,
    palletesation: PropTypes.arrayOf(
      PropTypes.shape({
        used: PropTypes.number.isRequired,
        type: PropTypes.number.isRequired,
        net_weight: PropTypes.number.isRequired,
      })
    ),
    created_at: PropTypes.string.isRequired,
    createdby: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
    updated_at: PropTypes.string.isRequired,
    updatedby: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    }),
  });

  // ✅ Define row PropTypes
  const rowShapemain = PropTypes.shape({
    original: rowOriginalShapemain.isRequired,
  });

  // ✅ Lot Number Cell Component
  const LotNumberCell = ({ row }) => (
    <a href={`/raw-materials-view/${row.original.id}`} className="">
      {row.original.lot_number}
    </a>
  );
  LotNumberCell.propTypes = {
    row: rowShapemain.isRequired,
  };




  // ✅ Define row.original PropTypes
  const rowOriginalShape2 = PropTypes.shape({
    shift_date: PropTypes.string.isRequired,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    location_name: PropTypes.shape({
      title: PropTypes.string,
    }),
    sum_net_weight: PropTypes.number.isRequired,
    net_weight_decay: PropTypes.number.isRequired,
    total_raw: PropTypes.number.isRequired,
  });

  // ✅ Define row PropTypes
  const rowShape2 = PropTypes.shape({
    original: rowOriginalShape2.isRequired,
  });



  // ✅ Location Cell Component
  const LocationCell2 = ({ row }) => (
    <a href={`/raw-materials-groupby/${row.original.shift_date}_${row.original.location}`} className="">
      {row.original.location_name ? row.original.location_name.title : ''}
    </a>
  );
  LocationCell2.propTypes = {
    row: rowShape2.isRequired,
  };



  // ✅ Location Cell Component
  const shiftDate = ({ row }) => (
    <a href={`/raw-materials-groupby/${row.original.shift_date}_${row.original.location}`} className="">
      {row.original.shift_date ? row.original.shift_date : ''}
    </a>
  );
  shiftDate.propTypes = {
    row: rowShape2.isRequired,
  };
  // ✅ Columns Definition 
  // Fetch Data using React Query
  const {
    data: queryData,
    isError,
    isRefetching,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "api/raw-materials/listing2",
      pagination.pageIndex,
      pagination.pageSize,
      columnFilters,
      globalFilter,
      sorting,
      formData, // Add formData to query key

    ],
    queryFn: async () => {
      try {
        console.log("Fetching with pagination:", {
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        });

        const response = await axios.post(
          `${base_url}/raw-materials/listing2`,
          {
            filters: columnFilters,
            search: globalFilter,
            page: pagination.pageIndex + 1, // API expects 1-based indexing
            pageSize: pagination.pageSize,
            // sorting: sorting.map(({ id, desc }) => ({
            //   column: id,
            //   order: desc ? "desc" : "asc",
            // })),
            formData: formData, // Include formData in the query
            sorting: sorting.map(({ id, desc }) => ({
              column: id,
              order: desc ? "desc" : "asc",
            })),
          },
          {
            headers: {
              Authorization: `Bearer ${Authtoken}`,
              Apitoken: Apitoken,
            },
          }
        );

        console.log("API Response:", response.data);

        if (response.data.code === 200) {
          return {
            data: Array.isArray(response.data.data?.supply_chain_headers)
              ? response.data.data.supply_chain_headers
              : [],
            meta: {
              totalRowCount: response.data.data?.totalRowCount || 0,
              pageCount: Math.ceil((response.data.data?.totalRowCount || 0) / pagination.pageSize)
            },
          };
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          data: [],
          meta: {
            totalRowCount: 0,
            pageCount: 0
          }
        };
      }
    },
    placeholderData: keepPreviousData,
  });

  const tableData = queryData?.data || [];
  const totalRowCount = queryData?.meta?.totalRowCount || 0;
  const pageCount = queryData?.meta?.pageCount || 0;

  useEffect(() => {
    console.log("Table Data:", tableData);
    console.log("Current Pagination:", pagination);
    console.log("Total Pages:", pageCount);
    console.log("Total Rows:", totalRowCount);
  }, [tableData, pagination, pageCount, totalRowCount]);



  // Define table columns
  const columns = useMemo(
    () => [

      {
        header: 'Lot Number',
        accessorKey: 'lot_number',
        Cell: LotNumberCell,
      },
      {
        accessorKey: 'product_name',
        header: 'Product',
      },
      {
        header: 'Location',
        accessorFn: (row) => (row.location_name ? row.location_name.title : ''),
      },
      {
        accessorKey: 'date_time',
        header: 'Date Time',
      },
      {
        header: 'Supplier',
        accessorFn: (row) => (row.supplier_name ? row.supplier_name.name : ''),
      },
      {
        accessorKey: 'note',
        header: 'Note',
      },

      // {
      //   header: 'BL Net Weight',
      //   accessorFn: (row) => {
      //     const netWeight = row.net_weight ?? 0; // Default to 0 if undefined or null
      //     return `${Number(netWeight).toFixed(2)} (KG)`;
      //   },
      // },
      {
        header: 'BL Net Weight',
        accessorFn: (row) => {
          let grade_a_net_weight = 0;
          if (row.id > 656) {
            grade_a_net_weight = (row.grade_a_bl_weight + row.grade_b_bl_weight);
          } else {
            if (row.id == 630 || row.id == 604 || row.id == 643 || row.id == 440 || row.id == 644 || row.id == 652) {
              grade_a_net_weight = (row.grade_a_bl_weight + row.grade_b_bl_weight);
            } else {
              grade_a_net_weight = row.net_weight;

            }
          }
          const netWeight = grade_a_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },
      {
        header: 'Net Weight',
        accessorFn: (row) => {
          const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },

      {
        header: 'Grade A BL Net Weight',
        accessorFn: (row) => {
          let grade_a_net_weight = 0;
          if (row.id > 357) {
            grade_a_net_weight = row.grade_a_bl_weight;
          } else {
            grade_a_net_weight = row.grade_a_net_weight;
          }
          const netWeight = grade_a_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },
      {
        header: 'Grade B BL Net Weight',
        accessorFn: (row) => {
          let grade_b_net_weight = 0;
          if (row.id > 357) {
            grade_b_net_weight = row.grade_b_bl_weight;
          } else {
            grade_b_net_weight = row.grade_b_net_weight;
          }

          const netWeight = grade_b_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },

      // {
      //     accessorKey: 'difference',
      //     header: 'Weight Difference',
      //   },
      {
        header: 'Weight Difference',
        accessorFn: (row) => {
          const netWeight = row.difference ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },
      {
        accessorKey: 'plate_number',
        header: 'Plate Number',
      },

      {
        header: 'Created At',
        accessorFn: (row) =>
          formatDistanceToNow(new Date(row.created_at), { addSuffix: true }),
      },
      {
        header: 'Created By',
        accessorFn: (row) =>
          row.createdby
            ? `${row.createdby.first_name} ${row.createdby.last_name}`
            : '',
      },
      {
        header: 'Updated At',
        accessorFn: (row) =>
          formatDistanceToNow(new Date(row.updated_at), { addSuffix: true }),
      },
      {
        header: 'Updated By',
        accessorFn: (row) =>
          row.updatedby
            ? `${row.updatedby.first_name} ${row.updatedby.last_name}`
            : '',
      },
    ],
    []
  );



  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post("/raw-materials/listing", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {


      if (response.data.code === 200) {

        setData(response.data.data.materials);
        setDataa(response.data.data.materials_groupby);
        setDataalocation(response.data.data.materials_groupby_location);

        let all_material = response.data.data.materials;
        // const sum_bl_net = all_material.reduce((sum, material) => {
        //   const material_weight = material.id > 357
        //     ? (material.grade_a_bl_weight + material.grade_b_bl_weight)
        //     : material.net_weight;
        //   return sum + material_weight;
        // }, 0);
        const sum_bl_net = all_material.reduce((sum, material) => {
          let material_weight = 0;

          if (material.id > 656) {
            material_weight = material.grade_a_bl_weight + material.grade_b_bl_weight;
          } else {
            if (
              material.id == 630 ||
              material.id == 604 ||
              material.id == 643 ||
              material.id == 652 ||
              material.id == 644 ||
              material.id == 440
            ) {
              material_weight = material.grade_a_bl_weight + material.grade_b_bl_weight;
            } else {
              material_weight = material.net_weight;
            }
          }
          return sum + material_weight;
        }, 0);

        setAllblnetweight(sum_bl_net);

        const total_net_weight = all_material.reduce((sum, item) => sum + item.total_net_weight, 0);
        setAllnetweight(total_net_weight);
        console.log(data);

      }
      else {
        //setBackendErrors(response.data.error);
      }
    })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });


    axios.post(
      `${base_url}/raw-materials/listing2`,
      {
        formData: formData,
        filters: columnFilters,
        search: globalFilter,
        page: pagination.pageIndex + 1, // API expects 1-based indexing
        pageSize: pagination.pageSize,
        // sorting: sorting.map(({ id, desc }) => ({
        //   column: id,
        //   order: desc ? "desc" : "asc",
        // })),
        sorting: sorting.map(({ id, desc }) => ({
          column: id,
          order: desc ? "desc" : "asc",
        })),
      },
      {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    ).then((response) => {
      if (response.data.code === 200) {
        // return {
        //   // data: Array.isArray(response.data?.data?.supply_chain_headers)
        //   //   ? response.data.data.supply_chain_headers
        //   //   : [],
        //   // meta: { 
        //   //   totalRowCount: response.data?.data?.totalRowCount || 0,
        //   //   pageCount: Math.ceil((response.data?.data?.totalRowCount || 0) / pagination.pageSize)
        //   // },


        // }
        //  refetch();
        queryClient.invalidateQueries({
          queryKey: ["api/raw-materials/listing2"]
        });



      } else {
        throw new Error("Failed to fetch data");
      }
    })





  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
    // delete backendErrors[Input_name];
  };

  useEffect(() => {
    setPermission(FindModuleById(42));
    console.log(permission);
    axios.post("/suppliers-trader/listing", {}, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    }
    ).then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.suppliers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setSupplierName(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });
    axios
      .post(
        "/raw-materials/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        setData(response.data.data.materials);
        setDataa(response.data.data.materials_groupby);
        setDataalocation(response.data.data.materials_groupby_location);

        let all_material = response.data.data.materials;
        const sum_bl_net = all_material.reduce((sum, material) => {
          const material_weight = material.id > 357
            ? (material.grade_a_bl_weight + material.grade_b_bl_weight)
            : material.net_weight;
          return sum + material_weight;
        }, 0);

        setAllblnetweight(sum_bl_net);


        const total_net_weight = all_material.reduce((sum, item) => sum + item.total_net_weight, 0);
        setAllnetweight(total_net_weight);
        console.log(data);



      })
      .catch((error) => {
        console.log(error);
      });


    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code == 200) {
          let locations = response.data.data.locations;
          let emp_statusList = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `sts-${index}`,
          }));


          setLocationLoading(emp_statusList);



        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/products/listing-groupby", {}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let farmers = response.data.data.products;
        let productslisting = farmers.map((customer, index) => ({
          label: customer.name,
          value: customer.name,
          symbol: customer.symbol,
          key: `product-${index}`
        }));
        setGroupproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const editItem = (item) => {
    window.location.href = "/raw-materials-edit/" + item;
  }
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/raw-materials/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/raw-materials";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  const printRawmaterial = (rawmaterial) => {


    $("#raw-material-" + rawmaterial.id + "").removeClass('loader-hide');
    $("#raw-material-" + rawmaterial.id + "").addClass('loader-show');

    axios.get(`/raw-materials/pdf-raw-material/${rawmaterial.id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let lot_number = rawmaterial.lot_number;
      let file_name = lot_number + '.pdf';
      link.download = file_name;
      link.click();

      $("#raw-material-" + rawmaterial.id + "").addClass('loader-hide');
      $("#raw-material-" + rawmaterial.id + "").removeClass('loader-show');

    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  }


  const printRawmaterialSupplier = (rawmaterial) => {


    $("#raw-rm-" + rawmaterial.id + "").removeClass('loader-hide');
    $("#raw-rm-" + rawmaterial.id + "").addClass('loader-show');

    axios.get(`/raw-materials/pdf-raw-material-supplier/${rawmaterial.id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let lot_number = rawmaterial.lot_number;
      let file_name = lot_number + '.pdf';
      link.download = file_name;
      link.click();

      $("#raw-rm-" + rawmaterial.id + "").addClass('loader-hide');
      $("#raw-rm-" + rawmaterial.id + "").removeClass('loader-show');

    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  }


  const printRawmaterialLotInfo = (rawmaterial) => {

    $("#raw-info-" + rawmaterial.id + "").removeClass('loader-hide');
    $("#raw-info-" + rawmaterial.id + "").addClass('loader-show');
    axios.get(`/raw-materials/pdf-raw-material-lot-info/${rawmaterial.id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let lot_number = rawmaterial.lot_number;
      let file_name = lot_number + ' Raw material Lot Info.pdf';
      // let file_name = 'Raw material Lot Info.pdf';
      link.download = file_name;
      link.click();
      $("#raw-info-" + rawmaterial.id + "").addClass('loader-hide');
      $("#raw-info-" + rawmaterial.id + "").removeClass('loader-show');
    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  }




  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columnss = [
    {
      header: 'Shift Date',
      accessorFn: (row) => row.shift_date,
      Cell: shiftDate,
    },
    {
      header: 'Location',
      accessorFn: (row) => (row.location_name ? row.location_name.title : ''),
      Cell: LocationCell2,
    },
    {
      header: 'BL Net Weight',
      // accessorFn: (row) => `${row.total_bl_net_weight.toFixed(2)} (KG)`,
      accessorFn: (row) => `${(row.total_bl_net_weight ?? 0).toFixed(2)} (KG)`,
    },
    {
      header: 'Net Weight',
      accessorFn: (row) => `${(row.sum_total_net_weight ?? 0).toFixed(2)} (KG)`,
    }
    ,

    {
      header: 'No of Receptions',
      accessorFn: (row) => `${row.total_raw}`,
    },
  ];


  // ✅ Define row.original PropTypes
  const rowOriginalShape = PropTypes.shape({
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    location_name: PropTypes.shape({
      title: PropTypes.string,
    }),
    sum_net_weight: PropTypes.number.isRequired,
    net_weight_decay: PropTypes.number.isRequired,
    total_raw: PropTypes.number.isRequired,
  });

  // ✅ Define row PropTypes
  const rowShape = PropTypes.shape({
    original: rowOriginalShape.isRequired,
  });

  // ✅ Location Cell Component
  const LocationCell = ({ row }) => (
    <a href={`/raw-materials-groupbylocation/${row.original.location}`} className="">
      {row.original.location_name ? row.original.location_name.title : ''}
    </a>
  );
  LocationCell.propTypes = {
    row: rowShape.isRequired,
  };

  // ✅ Columns Definition
  const columnss_locations = [
    {
      header: 'Location',
      accessorFn: (row) => (row.location_name ? row.location_name.title : ''),
      Cell: LocationCell,
    },
    // {
    //   header: 'Net Weight',
    //   accessorFn: (row) => `${row.sum_total_net_weight.toFixed(2)} (KG)`,
    // },
    {
      header: 'Net Weight',
      accessorFn: (row) => `${(row.sum_total_net_weight ?? 0).toFixed(2)} (KG)`,
    },

    {
      header: 'No of Receptions',
      accessorFn: (row) => `${row.total_raw}`,
    },
  ];


  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }

  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/raw-materials/listing-excel-open?${queryString}`, '_blank');

  }

  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, supplier: selectedOption.value });
  };
  const handleSelectChangeLocation = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, location: selectedOption.value });
  };
  const handleSelectChangeShift = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, shift: selectedOption.value });
  };

  const handleSelectChangeProduct = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, product: selectedOption.value });
  };




  useEffect(() => {
    const syncScrollbars = () => {
      const tableContainer = document.querySelector('.production-output-listing .MuiTableContainer-root');
      const topScroll = topScrollRef.current;
      const topScrollContent = topScroll?.querySelector('.top-scroll-content');

      if (tableContainer && topScroll && topScrollContent) {
        topScrollContent.style.width = `${tableContainer.scrollWidth}px`;

        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScroll.scrollLeft;
        };

        const handleTableScroll = () => {
          topScroll.scrollLeft = tableContainer.scrollLeft;
        };

        topScroll.addEventListener('scroll', handleTopScroll);
        tableContainer.addEventListener('scroll', handleTableScroll);

        return () => {
          topScroll.removeEventListener('scroll', handleTopScroll);
          tableContainer.removeEventListener('scroll', handleTableScroll);
        };
      }
    };

    const timer = setTimeout(syncScrollbars, 100);
    return () => clearTimeout(timer);
  }, [tableData]);

  const shiftlist = [
    { value: 1, label: "Shift 1" },
    { value: 2, label: "Shift 2" }
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Raw Materials</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Raw Materials Listing</li>
                  </ul>
                </div>
                <div className="col-auto">
                  {permission && permission.add === 1 && (
                    <Link to="/raw-materials-add" className="btn btn-primary me-1">
                      <i className="fas fa-plus"></i>
                    </Link>
                  )}



                  &nbsp;&nbsp;
                  {permission && permission.list === 1 && (<button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} />
                  </button>)}
                </div>
              </div>
            </div>
            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Supplier:</label>

                        <Select
                          options={supplierName}
                          name="supplier"
                          value={supplierName.find(option => option.value === formData.supplier) || null} // Ensure it selects the correct option
                          onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Date:</label>
                        <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Date:</label>
                        <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Location:</label>

                        <Select

                          options={locationLoading}
                          name="location"
                          value={locationLoading.find(option => option.value === formData.location) || null}
                          onChange={(selectedOption) => handleSelectChangeLocation(selectedOption)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Shift</label>
                        <Select
                          className="w-100"
                          value={shiftlist.find(option => option.value === formData.shift) || null}
                          name="shift"
                          onChange={(selectedOption) => handleSelectChangeShift(selectedOption)}
                          options={shiftlist}
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Product</label>
                        <Select
                          className="w-100"
                          value={groupproductLists.find(option => option.value === formData.product) || null}
                          name="shift"
                          onChange={(selectedOption) => handleSelectChangeProduct(selectedOption)}
                          options={groupproductLists}
                          placeholder="Select"
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/raw-materials" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>


                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
            {permission && permission.list === 1 && (
              <div className="row">

                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Net Weight </div>
                          <div className="dash-counts">
                            <p>{allnetweight.toFixed(2)}KG</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total BL Net weight</div>
                          <div className="dash-counts">
                            <p>{allblnetweight.toFixed(2)}KG</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


              </div>

            )}

            <div className="row">
              <div className="col-sm-12">
                {permission && permission.list === 1 && (
                  <section className="comp-section">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card bg-white">

                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">

                              <li className="nav-item">
                                <a className="nav-link " href="#listing-groupby" data-bs-toggle="tab">Raw Material Group by Shift date and Location</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-location" data-bs-toggle="tab"> Raw Material Group by Location</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link active" href="#listing-all" data-bs-toggle="tab"> Raw materials</a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div className="tab-pane " id="listing-groupby">
                                <div className="row" id="listing-followup-groupby" >
                                  <div className="col-sm-12" >
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnss} data={dataa}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="tab-pane " id="listing-location">
                                <div className="row" id="listing-location-groupby" >
                                  <div className="col-sm-12" >
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnss_locations} data={dataalocation}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="tab-pane show active" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <div
                                            ref={topScrollRef}
                                            className="top-scrollbar"
                                            style={{
                                              overflowX: 'auto',
                                              overflowY: 'hidden',
                                              marginBottom: '10px',
                                              height: '20px'
                                            }}
                                          >
                                            <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                          </div>
                                          <div className="table-responsive production-output-listing" ref={tableContainerRef}>
                                            <MaterialReactTable
                                              columns={columns}
                                              data={tableData}
                                              manualFiltering
                                              manualPagination
                                              manualSorting
                                              muiToolbarAlertBannerProps={
                                                isError
                                                  ? { color: "error", children: "Error loading data" }
                                                  : undefined
                                              }
                                              onColumnFiltersChange={setColumnFilters}
                                              onGlobalFilterChange={setGlobalFilter}
                                              onSortingChange={setSorting}
                                              onPaginationChange={setPagination}
                                              renderTopToolbarCustomActions={() => (
                                                <Tooltip arrow title="Refresh Data">
                                                  <IconButton onClick={() => refetch()}>
                                                    <RefreshIcon />
                                                  </IconButton>
                                                </Tooltip>
                                              )}
                                              rowCount={totalRowCount}
                                              pageCount={pageCount}
                                              enableDebug={true}
                                              state={{
                                                columnFilters,
                                                globalFilter,
                                                isLoading,
                                                pagination,
                                                showAlertBanner: isError,
                                                showProgressBars: isRefetching,
                                                sorting,
                                              }}
                                              enableRowActions
                                              renderRowActionMenuItems={({ row }) => [
                                                permission?.list === 1 && (
                                                  <MenuItem key="delete" onClick={() => printRawmaterial(row.original)}>
                                                    Print Raw Material <img id={`raw-material-${row.original.id}`} className="loader-image loader-hide" src={loader_image} />
                                                  </MenuItem>
                                                ),
                                                permission?.list === 1 && (
                                                  <MenuItem key="delete" onClick={() => printRawmaterialSupplier(row.original)}>
                                                    RM Supplier <img id={`raw-rm-${row.original.id}`} className="loader-image loader-hide" src={loader_image} />
                                                  </MenuItem>
                                                ),
                                                permission?.list === 1 && (
                                                  <MenuItem key="delete" onClick={() => printRawmaterialLotInfo(row.original)}>
                                                    Print LotInfo <img id={`raw-info-${row.original.id}`} className="loader-image loader-hide" src={loader_image} />
                                                  </MenuItem>
                                                ),
                                                permission?.update === 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete === 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}


                                            />
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RawMaterial;
